// extracted by mini-css-extract-plugin
module.exports = {"main":"rate_main__Jywgf"};